import React, { useState } from "react";
import "./validationExpired.css";
import { resendEmailVerification } from "../../services/rest/users/accountSettings";
import toast from "react-hot-toast";
import Loading from "../../components/Loading/Loading";
import { handleError } from "../../utils/handleError";
import { useNavigate } from "react-router-dom";

const ValidationExpired = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { value } = e.target;
    setEmail(value);
    setError("");
  };

  const handleSubmit = async () => {
    try {
      if (email === "") {
        setError("No puede estar vacío el correo");
        return;
      }
      setLoading(true);

      const response = await resendEmailVerification(email);
      toast.success(response.message, { duration: 10000 });
      setLoading(false);
      navigate("/auth");
    } catch (error) {
      const { message } = handleError(error);
      toast.error(message, { duration: 10000 });
      setLoading(false);
    }
  };

  return (
    <div className="container_verified ">
      <Loading loading={loading} />
      <section className="subwraper">
        <h1 className="text-center text-white fs-4">
          ¡Expiró el periodo de verificacion!
        </h1>
        <h1 className="text-center text-white fs-4">¡El enlace caduco!</h1>
        <div className="d-flex flex-column align-items-center gap-1">
          <span className="text-center text-white">
            Reenvie su email para solicitar una nueva verificación
          </span>
        </div>
        <div className="">
          <input
            type="email"
            className={`form-control ${
              error !== "" && "is-invalid input-error"
            } text-light`}
            id="inputEmailLogin"
            placeholder="correo@ejemplo.com"
            onChange={handleChange}
          />
          {error !== "" && (
            <div id="validationServer05Feedback" className="invalid-feedback">
              {error}
            </div>
          )}
        </div>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Reenviar
        </button>
      </section>
    </div>
  );
};

export default ValidationExpired;
